import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { oid, date } from '@/helpers/mongoHelpers'
import useCommon from '@/views/organization/useCommon'
import useCommonDeclaration from '../useCommonDeclaration'

export default function useDeclarationAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { config, createDocument, sendDocumentCreatedEmail } = useCommonDeclaration()
  const { formatDate } = useCommon()
  const isSubmitting = ref(false)

  async function create(data, documentFile) {
    isSubmitting.value = true

    try {
      const payload = {}

      // Campo principal: depende del tipo de declaración
      if (config.mainFieldKind === 'text') {
        // Supplier: nombre como texto libre
        if (data.nombre?.value) payload.nombre = data.nombre.value
      } else {
        // Lobby/Collaborator: trabajador como ObjectId (NO guardar nombre)
        if (data.trabajador?.value) payload.trabajador = oid(data.trabajador.value)
      }

      if (data.institucion?.value) payload.institucion = data.institucion.value
      if (data.area?.value) payload.area = oid(data.area.value)
      if (data.tipoDocumento?.value) payload.tipoDocumento = data.tipoDocumento.value
      if (data.tematica?.value) payload.tematica = data.tematica.value
      if (data.responsable?.value) payload.responsable = oid(data.responsable.value)
      if (data.empresas?.value?.length) payload.empresas = data.empresas.value.map(c => oid(c))
      if (data.observaciones?.value) payload.observaciones = data.observaciones.value
      if (data.fechaReunion?.value) payload.fechaReunion = date(formatDate(data.fechaReunion.value))
      if (data.fechaProximaRevision?.value) payload.fechaProximaRevision = date(formatDate(data.fechaProximaRevision.value))

      const file = documentFile?.name ? documentFile : null

      const docId = await createDocument(payload, file)

      // Send email to responsable de verificar
      if (data.responsable?.value) {
        sendDocumentCreatedEmail(docId, payload, data.responsable.value)
      }

      showSuccessMessage(i18n.t('declaration.created_success'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('declaration.error_create'))
    } finally {
      router.push({ name: `${config.routeName}-list` })
      isSubmitting.value = false
    }
  }

  return {
    create,
    isSubmitting,
  }
}
